module.exports = __webpack_public_path__ + "static/img/A76.b8c80939.jpg";